import { render } from "./EditProfileView.vue?vue&type=template&id=43a58f15&scoped=true"
import script from "./EditProfileView.vue?vue&type=script&lang=js"
export * from "./EditProfileView.vue?vue&type=script&lang=js"

import "./EditProfileView.vue?vue&type=style&index=0&id=43a58f15&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43a58f15"]])

export default __exports__